import { useEffect, useState } from "react";
import api from "@/lib/api";

// Loads an authenticated endpoint as a blob and returns an object URL.
// Needed because <video src> / <a href> can't carry the Authorization
// header that axios attaches, and auth cookies aren't usable on http://localhost
// (Secure + SameSite=None cookies are dropped over plain HTTP).
export function useBlobUrl(path, enabled = true) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!enabled || !path) { setUrl(null); return; }
    let objectUrl;
    let cancelled = false;
    // withCredentials: false — these requests can redirect cross-origin to
    // the Bunny CDN, which responds with Access-Control-Allow-Origin: *.
    // That's invalid combined with credentials, so the browser blocks it.
    // Auth here is via the Bearer header (attached by the axios instance),
    // not cookies, so dropping credentials is safe.
    api.get(path, { responseType: "blob", withCredentials: false })
      .then((res) => {
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [path, enabled]);

  return url;
}
